// extracted by mini-css-extract-plugin
export default {"app":"JoinRequest_app__W4fX8","headerBar":"JoinRequest_headerBar__JHWgn","view":"JoinRequest_view__s8OHx"};